/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MarketGoogleStoreProductSortUpdateRequest model module.
 * @module model/MarketGoogleStoreProductSortUpdateRequest
 * @version 1.0
 */
class MarketGoogleStoreProductSortUpdateRequest {
    /**
     * Constructs a new <code>MarketGoogleStoreProductSortUpdateRequest</code>.
     * @alias module:model/MarketGoogleStoreProductSortUpdateRequest
     */
    constructor() { 
        
        MarketGoogleStoreProductSortUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MarketGoogleStoreProductSortUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MarketGoogleStoreProductSortUpdateRequest} obj Optional instance to populate.
     * @return {module:model/MarketGoogleStoreProductSortUpdateRequest} The populated <code>MarketGoogleStoreProductSortUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MarketGoogleStoreProductSortUpdateRequest();

            if (data.hasOwnProperty('data')) {
                obj['data'] = ApiClient.convertToType(data['data'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MarketGoogleStoreProductSortUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MarketGoogleStoreProductSortUpdateRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['data'] && !(typeof data['data'] === 'string' || data['data'] instanceof String)) {
            throw new Error("Expected the field `data` to be a primitive type in the JSON string but got " + data['data']);
        }

        return true;
    }


}



/**
 * @member {String} data
 */
MarketGoogleStoreProductSortUpdateRequest.prototype['data'] = undefined;






export default MarketGoogleStoreProductSortUpdateRequest;

